export interface IUserDataResult {
    mobileNumberCoveredWithAsterisk: string;
    needFourDigitsAuthentication: boolean;
    needOtpCodeAuthentication: boolean;
    digitalCardStatus: DigitalCardStatus;
    isSso: boolean;
    cardColor: CardColor;
    cardName: string;
    cardIndex: number;
}

export enum DigitalCardStatus {
    None = 0,
    Ok = 1,
    OnlyNotValidDigitalCardsExist = 2,
    DigitalCardsNotExist = 3,
    MoreOneValidDigitalCardExist = 4,
    NeedUserLogin = 5,
    NeedToRegister = 6,
    NeedBank = 7,
    CardNotActivated = 8,
    NeedUserLoginOneVirtualCardBank = 9,
    UserLoginOtpNeedLoginUsername = 10,
    // Transfer Modes > 100
    SignAndWatch = 101
}

export enum CardColor {
    Black,
    White,
    Blue,
    Green,
    Clal
}
